import { PuffLoader } from 'react-spinners';
import styles from './spiner.module.scss';
import clsx from 'clsx';
interface Props {
    className?: string
}

export const Spiner: React.FC<Props> = ({ className }) => {
    return (
        <div className={clsx(styles.wrapper, className)}>
            <PuffLoader size={100} color="#F26A1C" />
        </div>
    );
};
